import type { Client, RequestContext } from "../client";
import type { RouteArgs } from "../resolver";
import type { DeploymentTargetResource, NewMachinePolicyResource, ResourceCollection } from "../resources";
import type { MachinePolicyResource, WorkerMachineResource } from "../resources/index";
import { BasicRepository, type ListArgs } from "./basicRepository";
export type MachinePolicyListArgs = ListArgs & RouteArgs & {
    partialName?: string;
};
export class MachinePolicyRepository extends BasicRepository<MachinePolicyResource, NewMachinePolicyResource, MachinePolicyListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("MachinePolicies", client, requestContext);
    }
    getTemplate(): Promise<MachinePolicyResource> {
        return this.client.get(this.requestContext, this.client.getLink("MachinePolicyTemplate"));
    }
    getMachines(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<DeploymentTargetResource>> {
        return this.client.get(this.requestContext, machinePolicy.Links["Machines"]);
    }
    getWorkers(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<WorkerMachineResource>> {
        return this.client.get(this.requestContext, machinePolicy.Links["Workers"]);
    }
}
